<template>
	<div class="app-vue" v-cloak>
		<router-view></router-view>
	</div>
</template>
<script>
//import axios from 'axios';
import axios from "./libs/axiosInterceptor.js";
export default {
	data() {
		return {
    }
	},
  beforeMount() {

		axios.defaults.withCredentials = true;
		axios.defaults.baseURL = '/';
		// axios.defaults.timeout = 300000;
		// this.setAxiosRequestUse();
		// this.setAxiosResponseUse();
		// this.findViewByRoleCode();

	},
	beforeDestroy() {

	},
	methods: {
		findViewByRoleCode() {
			let _this = this;
			let _param = {
				'roleCode': 'SA'
			}
			_this.axios.findViewByRoleCode(_param).then(data => {
				console.log(data);
			}).catch(error => {
				console.log(error);
			})
		},
		setAxiosRequestUse() {
			let _this = this;
			let _longTimeAccessList = ['api/upload', 'api/download'];
			axios.interceptors.request.use(function (config) {
				if (_this.Util.getSession('tmp_access_token')) {
					config.headers.Authorization = `Bearer ${_this.Util.getSession('tmp_access_token')}`;
				}
				if (_this.operatorId && _this.operatorId.length > 0) {
					if (Object.prototype.toString.call(config.data) === '[object FormData]') {
						config.data.append('operatorId', _this.operatorId);
					} else {
						config.data.operatorId = _this.operatorId;
					}
				}
				if (_longTimeAccessList.indexOf(config.url) >= 0) {
					config.timeout = 10 * 60 * 1000;
				} else {
					config.timeout = 60 * 1000;
				}
				return config;
			}, function (err) {
				return Promise.reject(err);
			});
		},
		setAxiosResponseUse() {
			let _this = this;
			axios.interceptors.response.use(function (res) {
				return res.data;
			}, function (err) {
				console.log(err)
				let error = { "errcode": "0", "errmsg": "success", "errParam": null, "result": {} };
				if (err.message.indexOf('timeout') > -1) {
					error.errmsg = '请求超时!';
					return Promise.resolve(error)
				}
				if (err.message.indexOf('Network Error') > -1) {
					error.errmsg = '网络好像有点问题，请稍候再重试！!';
					return Promise.resolve(error);
				}
				if (err.response.status === 401) {
					_this.hideLoading();
					_this.$Modal.error({
						title: "温馨提示",
						content: "登录信息已过期，请重新登录！",
						onOk() {
							setTimeout(function () {
								_this.Util.removeSession('tmp_login_user');
								_this.setOperatorId('');
								_this.$router.push('login');
							}, 200);
						}
					});
					return Promise.resolve(error);
				} else {
					return Promise.reject(err);
				}
			});
		}
	}
}
</script>
<style lang="less">
	@import 'styles/common.less';
	@import 'styles/pic.less';
	@import "../theme/index.less";

	.app-vue {
		width: 100%;
		height: 100%;
	}

	.ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
		background: #515a6e;
	}
	.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu) {
		color: #fff;
	}

	.ivu-btn-text {
		color: @btn-text-color;
	}
</style>



// WEBPACK FOOTER //
// app.vue?947862ba